<template>
  <div class="m-4 overflow-auto">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Group Types</h5>
    </div>
    <div class="treeview">
      <ul class="treeview-ul">
        <group-session-type-crud-item
          v-for="item in tree"
          :key="item.item.id"
          :item="item"
          @add-item="addGroupType($event)"
          @edit-item="editGroupType($event)"
          @delete-item="deleteGroupType($event)"
          :level="0"
        />
      </ul>
      <b-button
        class="ml-2"
        variant="outline-primary"
        size="sm"
        @click="addGroupType({ parentId: null })"
      >
        +
      </b-button>
    </div>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit GroupType' : 'Add GroupType'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitGroupType"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group label="Type">
        <b-form-input v-model="form.type" trim maxLength="255"></b-form-input>
      </b-form-group>
      <b-form-group label="Detail">
        <b-form-textarea v-model="form.details" rows="20"></b-form-textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import groupSessionTypeServer from "../../server/groupSessionType";
import GroupSessionTypeCrudItem from "./GroupSessionTypeCrudItem.vue";
import { mapActions } from "vuex";

const buildTree = (list, rootId) => {
  let tree = [];
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    if (item.parentId == rootId) {
      let treeItem = {
        item: item,
        subItems: buildTree(list, item.id)
      };
      tree.push(treeItem);
    }
  }
  return tree;
};

export default {
  name: "GroupSessionTypeCrud",
  components: { GroupSessionTypeCrudItem },
  data() {
    return {
      list: [],
      formId: null,
      form: {
        type: "",
        details: "",
        parentId: null
      }
    };
  },
  mounted() {
    this.getGroupTypes();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getGroupTypes() {
      this.list = await groupSessionTypeServer.query();
    },
    async submitGroupType() {
      const formData = {
        type: this.form.type,
        details: this.form.details,
        parentId: this.form.parentId
      };
      if (this.formId) {
        await groupSessionTypeServer.update(this.formId, formData);
      } else {
        await groupSessionTypeServer.create(formData);
      }
      this.getGroupTypes();
      this.showAlertSuccess();
    },
    addGroupType({ parentId }) {
      this.formId = null;
      this.form = {
        type: "",
        details: "",
        parentId: parentId
      };
      this.$refs["form-modal"].show();
    },
    editGroupType({ data }) {
      this.formId = data.id;
      this.form = {
        type: data.type,
        details: data.details,
        parentId: data.parentId
      };
      this.$refs["form-modal"].show();
    },
    deleteGroupType({ id }) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await groupSessionTypeServer.delete(id);
          this.getGroupTypes();
          this.showAlertSuccess();
        })
        .catch(function() {});
    }
  },
  computed: {
    tree() {
      return buildTree(this.list, null);
    }
  }
};
</script>

<style>
.treeview {
  height: calc(100vh - 188px);
}
.treeview .btn-default {
  border-color: #e3e5ef;
}
.treeview .btn-default:hover {
  background-color: #f7faea;
  color: #bada55;
}
.treeview ul {
  list-style: none;
  padding-left: 10px;
}
.treeview ul li {
  padding: 20px 0px 0px 35px;
  position: relative;
}
.treeview ul li:before {
  content: "";
  position: absolute;
  top: -26px;
  left: -17px;
  border-left: 2px dashed #a2a5b5;
  width: 1px;
  height: 100%;
}
.treeview ul li:after {
  content: "";
  position: absolute;
  border-top: 2px dashed #a2a5b5;
  top: 32px;
  left: -17px;
  width: 38px;
}
.treeview ul li:last-child:before {
  top: -22px;
  left: -17px;
  height: 56px;
}
.treeview > ul > li:after,
.treeview > ul > li:last-child:before {
  content: unset;
}
.treeview > ul > li:before {
  top: 45px;
  left: 28px;
}
.treeview > ul > li:not(:last-child) > ul > li:before {
  content: unset;
}
.treeview > ul > li > .treeview__level:before {
  height: 40px;
  width: 40px;
  top: -8.5px;
  font-size: 22px;
}
.treeview > ul > li > ul {
  padding-left: 10px;
}
.treeview__level {
  padding: 7px;
  padding-left: 16.5px;
  display: inline-block;
  border-radius: 5px;
  font-weight: 700;
  border: 1px solid #e3e5ef;
  position: relative;
  z-index: 1;
  min-height: 26px;
  min-width: 200px;
  max-width: 400px;
  line-height: 1;
  font-size: 12px;
}
.treeview__level:before {
  content: attr(data-level);
  position: absolute;
  left: -27.5px;
  top: -8.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 7.5px solid var(--border-circle-color);
  background-color: var(--bg-circle-color);
  color: #fff;
  font-size: 20px;
}
.treeview__level-btns {
  margin-left: 15px;
  display: inline-block;
  position: relative;
}
.treeview__level .level-same,
.treeview__level .level-sub {
  position: absolute;
  display: none;
  transition: opacity 250ms cubic-bezier(0.7, 0, 0.3, 1);
}
.treeview__level .level-same.in,
.treeview__level .level-sub.in {
  display: block;
}
.treeview__level .level-same.in .btn-default,
.treeview__level .level-sub.in .btn-default {
  background-color: #faeaea;
  color: #da5555;
}
.treeview__level .level-same {
  top: 0;
  left: 45px;
}
.treeview__level .level-sub {
  top: 42px;
  left: 0px;
}
.treeview__level .level-remove {
  display: none;
}
.treeview__level.selected {
  background-color: #f9f9fb;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.1);
}
.treeview__level.selected .level-remove {
  display: inline-block;
}
.treeview__level.selected .level-add {
  display: none;
}
.treeview__level.selected .level-same,
.treeview__level.selected .level-sub {
  display: none;
}
.treeview .level-title {
  cursor: pointer;
  user-select: none;
}
.treeview .level-title:hover {
  text-decoration: underline;
}
.treeview--mapview ul {
  justify-content: center;
  display: flex;
}
.treeview--mapview ul li:before {
  content: unset;
}
.treeview--mapview ul li:after {
  content: unset;
}
</style>
